import { createReducer } from '@reduxjs/toolkit';
import {
  isSortingFieldKey,
  isSortingOrder,
  SortingFieldKey,
  SortingOrder,
  SortingShape,
} from './model';
import * as sortingActions from './actions';
import * as lastStateActions from '../lastState/actions';

const initial: SortingShape = {
  order: SortingOrder.desc,
  fieldKey: SortingFieldKey.created_at,
};

export const sortingReducer = createReducer<SortingShape>(initial, (builder) =>
  builder
    .addCase(sortingActions.sortingChanged, (s, a) => {
      s.order = a.payload.order;
      s.fieldKey = a.payload.fieldKey;
    })
    .addCase(lastStateActions.applied, (s, a) => {
      if (a.payload) {
        const { order, fieldKey } = a.payload.state.data.sorting;
        if (isSortingOrder(order)) {
          s.order = order;
        }
        if (isSortingFieldKey(fieldKey)) {
          s.fieldKey = fieldKey;
        }
      } else {
        s.order = initial.order;
        s.fieldKey = initial.fieldKey;
      }
    }),
);
